"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LightButton = _interopRequireDefault(require("../buttons/LightButton"));

var _Icon = _interopRequireDefault(require("../../icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DropArea = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center justify-content-center"
  };
}).withConfig({
  displayName: "BrowseFiles__DropArea",
  componentId: "lfxksz-0"
})(["border-radius:4px;border:1px dashed ", ";background-color:", ";width:100%;height:36px;"], function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["almost-white"];
});

var DropAreaWrapper = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center"
  };
}).withConfig({
  displayName: "BrowseFiles__DropAreaWrapper",
  componentId: "lfxksz-1"
})(["height:36px;width:100%;margin-bottom:10px;"]);

var DropAreaText = _styledComponents["default"].span.withConfig({
  displayName: "BrowseFiles__DropAreaText",
  componentId: "lfxksz-2"
})(["font-size:0.9rem;color:", ";"], function (props) {
  return props.theme["grey"];
});

var DownloadLink = _styledComponents["default"].a.attrs(function () {
  return {
    className: "mr-1"
  };
}).withConfig({
  displayName: "BrowseFiles__DownloadLink",
  componentId: "lfxksz-3"
})(["&&&{color:#2b77eb;&:hover{cursor:pointer;}text-decoration:none;}"]);

var DownloadLinkHolder = _styledComponents["default"].span.attrs(function () {
  return {
    className: "d-flex justify-content-between align-items-center px-2"
  };
}).withConfig({
  displayName: "BrowseFiles__DownloadLinkHolder",
  componentId: "lfxksz-4"
})(["width:100%;"]);

var BrowseFiles = function BrowseFiles(_ref) {
  var fileTypes = _ref.fileTypes,
      onFileAdd = _ref.onFileAdd,
      placeholder = _ref.placeholder,
      buttonText = _ref.buttonText,
      file = _ref.file,
      fileContent = _ref.fileContent;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      localFileContent = _useState2[0],
      setLocalFileContent = _useState2[1];

  (0, _react.useEffect)(function () {
    if (file && file.name) {
      var reader = new FileReader();

      reader.onload = function () {
        setLocalFileContent(reader.result);
      };

      reader.readAsDataURL(file);
    } else {
      setLocalFileContent("");
    }
  }, [file]);

  var getFileTypes = function getFileTypes() {
    if (Array.isArray(fileTypes)) {
      // Given an array of file types, join them with commas
      return fileTypes.join(", ");
    } else if (typeof fileTypes === "string") {
      // Given a string, just use that as the file type
      return fileTypes;
    } else {
      // By passing null, it will allow all file types
      return null;
    }
  };

  return _react["default"].createElement("div", {
    className: "dropzone"
  }, _react["default"].createElement(_reactDropzone["default"], {
    accept: getFileTypes(),
    onDrop: function onDrop(accepted, rejected) {
      // Call the provided onChange function with the new file(s) added
      onFileAdd(accepted);
    },
    disableClick: true
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps,
        open = _ref2.open;
    return _react["default"].createElement("div", getRootProps(), _react["default"].createElement("input", getInputProps()), _react["default"].createElement(DropAreaWrapper, null, _react["default"].createElement(DropArea, null, file && file.name ? _react["default"].createElement(DownloadLinkHolder, null, _react["default"].createElement(DownloadLink, {
      href: fileContent || localFileContent,
      download: file.name
    }, file.name), _react["default"].createElement(_Icon["default"], {
      iconName: "fa-trash-alt",
      onClick: function onClick() {
        return onFileAdd({});
      },
      styles: {
        size: ".9rem"
      }
    })) : _react["default"].createElement(DropAreaText, null, placeholder)), _react["default"].createElement(_LightButton["default"], {
      className: "ml-1",
      onClick: function onClick() {
        return open();
      }
    }, buttonText)));
  }));
};

BrowseFiles.propTypes = {
  fileTypes: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  onFileAdd: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  file: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    lastModified: _propTypes["default"].number,
    lastModifiedDate: _propTypes["default"].any,
    webkitRelativePath: _propTypes["default"].string,
    size: _propTypes["default"].number,
    type: _propTypes["default"].string,
    path: _propTypes["default"].string
  }),
  fileContent: _propTypes["default"].string
};
BrowseFiles.defaultProps = {
  fileTypes: [],
  placeholder: "drop files here (or click browse)",
  buttonText: "Browse",
  file: {},
  fileContent: null
};
var _default = BrowseFiles;
exports["default"] = _default;